import { Dispatch } from 'redux';

export const ACTIONS_RESET_DATA = 'COMMON/RESET_DATA';

export interface ResetDataAction {
  type: typeof ACTIONS_RESET_DATA;
}

export const actions = {
  clearData: (onComplete?: () => void) => async (dispatch: Dispatch) => {
    await dispatch({ type: ACTIONS_RESET_DATA });
    if (onComplete) {
      onComplete();
    }
  },
};

export default { actions };
